<template>
  <div>
    <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="ipagination"
        :loading="loading"
        rowKey="id"
        @change="handleTableChange">
      <span slot="action" slot-scope="text, record">
          <a @click="checkReport(record.reportId,record.keyword)">查看报告</a>
      </span>
    </a-table>
  </div>
</template>

<script>
import {getAction} from "@/api/manage";

export default {
  name: "ReportLog",
  data() {
    return {
      dataSource: [],
      columns: [
        {
          title: '关键词',
          dataIndex: 'keyword',
          width: '30%',
        },
        {
          title: '报告日期',
          dataIndex: 'createTime',
          width: '20%',
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: "center",
          width: '10%',
          scopedSlots: {customRender: 'action'},
        }
      ],
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '30', '50'],
        showTotal: (total, range) => {
          return "第" + range[0] + "至" + range[1] + "条,共" + total + "条"
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
      },
      loading: false,
      queryParam: {},
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      /* 筛选参数 */
      filters: {},
    }
  },
  created() {
    this.dataList()
  },
  methods: {
    handleTableChange(pagination, filters, sorter) {
      if (Object.keys(sorter).length > 0) {
        this.isorter.column = sorter.field;
        this.isorter.order = "ascend" == sorter.order ? "asc" : "desc"
      }
      this.ipagination = pagination;
      this.dataList();
    },
    checkReport(id,keyword) {
      // getAction('/pdf/getReportDetails', {reportId:id}).then(res => {
      //   if (res.success) {
      //   }
      // })
      if(!id){
        this.$message.warning('暂无报告下载！')
        return ;
      }

      let routeData = this.$router.resolve({name: 'report-details', query: {reportId: id,name:keyword}});
      window.open(routeData.href, '_blank');
    },
    dataList(arg) {
      if (arg === 1) {
        this.ipagination.current = 1;
      }
      var param = {};
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      this.loading = true;
      getAction('/log/reportLogs', param).then(res => {
        if (res.success) {
          this.loading = false;
          this.dataSource = res.data.records;
          this.ipagination.total = res.data.total;
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
